import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResultConfigViewModel } from 'src/app/models/results/result-config-view-model';
import { InventoryItemDTO } from 'src/app/models/results/inventory-item-dto';

@Injectable({
  providedIn: 'root'
})
export abstract class DataService {
  abstract updateResultConfigItem(item: ResultConfigViewModel): Promise<void>;
  abstract getAdminEmailAddresses(): Observable<string[]>;
  abstract executeDatabaseQuery(queryFn?: any): Observable<InventoryItemDTO[]>;
}
